export interface IFlightInfo {
  id: number;
  departureAirport: IAirport;
  arrivalAirport: IAirport;
  flightNumbers: [IFlightNumber];
}

export interface IAirport {
  iataCode: string;
  terminal: string;
  date: string;
  time: ITime;
}

export interface ITime {
  hour: number;
  minute: number;
  second: number;
  nano: number;
}

export interface IFlightNumber {
  id: number;
  carrierIataCode: string;
  flightNumber: string;
}

export interface IFlightInfoRequestParams {
  iataFlightNumber?: string;
  flightNumber?: string;
  carrierIataCode?: string;
  departureDate?: string;
  arrivalDate?: string;
  departureAirportIataCode?: string;
  arrivalAirportIataCode?: string;
}

export interface IFlightsByHubIdsRequestParams {
  departureAirportIataCode: string;
  arrivalAirportIataCode: string;
  arrivalDateTime: string;
}

export interface IFlightsInfo {
  flightDesignators: {
    airlineCode: string;
    flightNumber: string;
    airlineName: string;
  }[];
  originalDepartureTimeLocal: string
  originalArrivalTimeLocal: string
}
export interface IFlightStatus {
  iataCode: string;
  scheduledLocalTime: string;
  estimatedLocalTime: string;
  accuracy: string;
  terminal: string;
  gate: string;
  baggageClaim: string;
  timeDifferenceInMinutes: number;
  flightTimeLocal: string;
  flightTimeUtc: string;
}

export interface IFlightUpdate {
  flightStatus: FlightStatus;
  scheduleStatus: ScheduleStatus;
  diversionStatus: DiversionStatus;
  departure: IFlightStatus;
  arrival: IFlightStatus;
  created: string;
}


export interface IFlightTracker {
  id: number;
  status: Status;
  journeyId: number;
  flightId: number;
  updated: string;
  usedFlightDesignator: {
    airlineIataCode: string,
    flightNumber: number,
  },
  originalDepartureTimeLocal: string;
  originalArrivalTimeLocal: string;
  lastUpdate: IFlightUpdate;
  statusUpdates: IFlightUpdate[];
}

export interface  IFlightDesignator {
  flightNumber: string;
  airlineCode: string;
  primary: boolean;
}

export interface IFLightResponse {
  id: number;
  flightDesignators: IFlightDesignator[];
  originalDepartureTimeLocal: string;
  departureAirportIataCode: string;
  originalArrivalTimeLocal: string;
  arrivalAirportIataCode: string;
  trackingActive: boolean;
  departureTimeDifferenceInMinutes: number;
  arrivalTimeDifferenceInMinutes: number;
  statusUpdates: IFlightInfoUpdate[];
}

export interface IFlightAirportInfo {
  terminal: string;
  gate: string;
  baggageClaim: string;
  flightTimeLocal: string;
  flightTimeUtc: string;
  accuracy: FlightAccuracy;
  flightTimeType: FlightTimeType;
}

export interface IFlightInfoUpdate {
  status: FlightStatus;
  scheduleStatus: ScheduleStatus;
  diversionStatus: DiversionStatus;
  departureInfo: IFlightAirportInfo;
  arrivalInfo: IFlightAirportInfo;
  created: string;
}

export interface IAirportInfo {
  name: string;
  iataCode: string;
  cityName: string;
  countryCode: string;
  timeZoneId: string;
}

export interface IAirlineInfo {
  name: string;
  iataCode: string;
  icaoCode: string;
  flightMatchingKeywords: string[];
}

export interface IAirportByIATACodeRequestParams {
  iataCode: string;
}

export interface IAirportDetails {
  name: string;
  iataCode: string;
  cityName: string;
  countryCode: string;
}

export enum Status {
  notStarted = 'NOT_STARTED',
  noFlightDesignator = 'NO_FLIGHT_DESIGNATOR',
  invalidFlightDesignator = 'INVALID_FLIGHT_DESIGNATOR',
  active= 'ACTIVE',
  finished= 'FINISHED',
}

export enum FlightStatus {
  unknown = 'UNKNOWN',
  scheduled = 'SCHEDULED',
  boarding = 'BOARDING',
  outOfGate= 'OUT_OF_GATE',
  inAir= 'IN_AIR',
  landed = 'LANDED',
  arrived = 'ARRIVED',
  delayed= 'DELAYED',
  cancelled= 'CANCELLED'
}

export enum ScheduleStatus {
  unknown = 'UNKNOWN',
  departureEarly = 'DEPARTURE_EARLY',
  departureOnTime = 'DEPARTURE_ON_TIME',
  departureDelay= 'DEPARTURE_DELAY',
  arrivalEarly= 'ARRIVAL_EARLY',
  arrivalOnTime = 'ARRIVAL_ON_TIME',
  arrivalDelay = 'ARRIVAL_DELAY',
}

export enum DiversionStatus {
  diverted = 'DIVERTED',
  recovery = 'RECOVERY',
  none = 'NONE',
}

export enum FlightAccuracy {
  SCHEDULED = 'SCHEDULED',
  ESTIMATED = 'ESTIMATED',
  ACTUAL = 'ACTUAL',
  UNKNOWN = 'UNKNOWN',
}

export enum FlightTimeType {
  GATE = 'GATE',
  RUNWAY = 'RUNWAY',
}
